import { Component } from 'react'

// TNMC-236: without a boundary, any render error (including a chunk that
// lazyWithReload gave up on) unmounts the whole app and leaves a blank screen.
// resetKey clears the error when it changes, e.g. on navigation, without
// remounting the children.
class AppErrorBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null })
    }
  }

  render() {
    if (!this.state.error) return this.props.children

    return (
      <div className="hero min-h-[50vh]">
        <div className="hero-content text-center">
          <div className="max-w-md">
            <h1 className="text-2xl font-bold">This page didn't load</h1>
            <p className="py-4">Reloading usually fixes it. If it keeps happening, please contact support.</p>
            <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
              Reload
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default AppErrorBoundary
